// Action-item convention: a sticky is an "action" if its `tags` array
// contains the string ACTION_TAG. We piggyback on the existing
// `Sticky.tags?: string[]` field (defined in packages/shared/src/shapes.ts)
// rather than introducing a separate shape type — keeps the data model
// flat and lets the sticky's existing UX (drag, color, text editing)
// apply unchanged.
//
// The sidebar uses `isActionItem` to filter; the "Mark as action" button
// toggles the tag. During the `actions` retro phase the sidebar is the
// primary surface; outside that phase the sidebar can still mount if the
// user wants to manage their list, but the chrome hides it by default.

import type { Shape, Sticky } from '@frame/shared';
import { getShapesMap, LOCAL_ORIGIN_EDIT } from '../canvas/binding/shapesMap';
import type * as Y from 'yjs';

export const ACTION_TAG = 'action';

export function isActionItem(shape: Shape): shape is Sticky {
  if (shape.type !== 'sticky') return false;
  const tags = shape.tags;
  return Array.isArray(tags) && tags.includes(ACTION_TAG);
}

export function toggleActionItem(doc: Y.Doc, shapeId: string): void {
  const ymap = getShapesMap(doc).get(shapeId);
  if (!ymap) return;
  if (ymap.get('type') !== 'sticky') return;
  const tags = (ymap.get('tags') as string[] | undefined) ?? [];
  const has = tags.includes(ACTION_TAG);
  const next = has ? tags.filter((t) => t !== ACTION_TAG) : [...tags, ACTION_TAG];
  doc.transact(() => {
    ymap.set('tags', next);
  }, LOCAL_ORIGIN_EDIT);
}
